<i18n>
en:
  title: "Recipe"
ja:
  title: "レシピ"
</i18n>

<template lang="pug">
  div
    //- タイトル
    v-img(:src="require(`@/assets/images/header-back-entry-shop.png`)" min-height="180px")
      v-row.fill-height(align="center")
        v-col(align="center")
          h1.white--text|{{$t('title')}}

    //- コンテンツ
    v-container
      v-row
        v-col(cols="12" sm="6")
          v-img(src="@/assets/recipe.webp")

        v-col(cols="12" sm="6")
          div|旨味じゅわ〜っ！とろとろ！
          h2|鶏むね肉となすの生姜焼き
          p.my-4|鶏肉となすに片栗粉をまぶすことで、焼いている時に旨味が逃げず、食べた瞬間じゅわ〜っと旨味が溢れ出します♪♪手軽に作れるので、お弁当にもおすすめです！
          v-chip(outlined label)
            v-icon(dense left)|fa-user-clock
            |調理時間 約20分

        v-col(cols="12")
          h3|材料

        v-col(cols="12" sm="6")
          v-row
            v-col.py-1(cols="12")
              div.d-flex.flex-row
                div|鶏むね肉
                v-divider.align-self-center.mx-3
                div|1枚(200g)
            v-col.py-1(cols="12")
              div.d-flex.flex-row
                div|ナス
                v-divider.align-self-center.mx-3
                div|2本
            v-col.py-1(cols="12")
              div.d-flex.flex-row
                div|酒
                v-divider.align-self-center.mx-3
                div|大さじ1
            v-col.py-1(cols="12")
              div.d-flex.flex-row
                div|塩コショウ
                v-divider.align-self-center.mx-3
                div|少々
            v-col.py-1(cols="12")
              div.d-flex.flex-row
                div|片栗粉
                v-divider.align-self-center.mx-3
                div|適量
            v-col.py-1(cols="12")
              div.d-flex.flex-row
                div|サラダ油
                v-divider.align-self-center.mx-3
                div|大さじ3
            v-col.py-1(cols="12")
              div.d-flex.flex-row
                div|細ねぎ(刻み)
                v-divider.align-self-center.mx-3
                div|適量

        v-col(cols="12" sm="6")
          h4.font-weight-regular|☆調味料
          v-row
            v-col.py-1(cols="12")
              div.d-flex.flex-row
                div|酒
                v-divider.align-self-center.mx-3
                div|大さじ2
            v-col.py-1(cols="12")
              div.d-flex.flex-row
                div|みりん
                v-divider.align-self-center.mx-3
                div|大さじ1
            v-col.py-1(cols="12")
              div.d-flex.flex-row
                div|砂糖
                v-divider.align-self-center.mx-3
                div|大さじ1/2
            v-col.py-1(cols="12")
              div.d-flex.flex-row
                div|醤油
                v-divider.align-self-center.mx-3
                div|大さじ1 と 大さじ1/2
            v-col.py-1(cols="12")
              div.d-flex.flex-row
                div|おろし生姜
                v-divider.align-self-center.mx-3
                div|大さじ1/2

        v-col(cols="12")
          h3|作り方

        v-col(cols="12" md="6")
          v-card(outlined)
            v-card-title|1.
            v-card-text
              v-img(src="@/assets/recipe1.png")
              div.recipe-explanation|鶏肉は一口大に切り、酒、塩こしょうをふって5分程おき、キッチンペーパーで水気をふきとり、片栗粉をまぶす。
        v-col(cols="12" md="6")
          v-card(outlined)
            v-card-title|2.
            v-card-text
              v-img(src="@/assets/recipe2.png")
              div.recipe-explanation|なすはへたを切り落として1.5cm幅の輪切りにする。水に5分程さらしてキッチンペーパーで水気をふきとり、片栗粉をまぶす。
        v-col(cols="12" md="6")
          v-card(outlined)
            v-card-title|3.
            v-card-text
              v-img(src="@/assets/recipe3.png")
              div.recipe-explanation|フライパンにサラダ油を入れて中火で熱し、鶏肉、なすを入れて両面こんがりとするまで焼き、☆を加えて混ぜながらとろみがつくまで、煮からめる。
        v-col(cols="12" md="6")
          v-card(outlined)
            v-card-title|4.
            v-card-text
              v-img(src="@/assets/recipe4.png")
              div.recipe-explanation|器に盛り、細ねぎをちらす。
</template>

<script>
export default {
}
</script>

<style lang="sass" scoped>
h1
  font-size: 48px
  word-break: keep-all

.recipe-explanation
  white-space: pre-line
</style>
